import angular from 'angular';
import FlowsImInBridge from './FlowsImInBridge';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
///
/// This state displays flows the user is involved in or can access.
///
angular
  .module('flowingly.runner.flows.imin', [])
  .component('flowsImIn', FlowsImInBridge)
  .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.flowsin, {
    url: 'flowsin',
    params: { title: "Flows I'm In", backFromState: '' },
    controller: [
      function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const $ctrl = this;
      }
    ],
    controllerAs: '$ctrl',
    template: `<flows-im-in></flows-im-in>`
  });
}
